var _rect, _rect2, _g, _rect3, _rect4, _g2, _rect5, _rect6, _g3, _rect7, _rect8, _g4, _rect9, _rect10, _g5, _rect11, _rect12, _g6, _rect13, _rect14, _g7, _rect15, _rect16, _g8, _rect17, _rect18, _g9, _rect19, _rect20, _g10, _rect21, _rect22, _g11, _rect23, _rect24, _g12, _rect25, _rect26, _g13, _rect27, _rect28, _g14, _rect29, _rect30, _g15, _rect31, _rect32, _g16, _rect33, _rect34, _g17, _rect35, _path, _g18, _rect36, _rect37, _g19, _rect38, _rect39, _g20, _rect40, _rect41, _g21, _rect42, _rect43, _g22, _rect44, _rect45, _g23, _rect46, _rect47, _g24, _rect48, _rect49, _g25, _path2, _path3, _path4, _path5, _path6, _path7, _rect50, _rect51, _rect52, _path8, _path9, _rect53, _rect54, _rect55, _path10, _path11, _rect56, _rect57, _rect58, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1278,
    height: 1797,
    viewBox: "0 0 1278 1797",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 256,
    height: 360
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0762 270.576C53.0762 265.434 57.2446 261.266 62.3867 261.266H193.372C198.514 261.266 202.683 265.434 202.683 270.576V362.39H53.0762V270.576Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5659 151.694C25.6497 149.722 25.6497 146.536 27.5659 144.565C41.7956 129.925 50.5582 109.943 50.5582 87.9144C50.5582 70.6611 45.1829 54.6633 36.0156 41.5043C33.7062 38.1893 35.9415 33.2866 39.9818 33.2866H215.777C219.818 33.2866 222.053 38.1893 219.743 41.5043C210.576 54.6633 205.201 70.6611 205.201 87.9144C205.201 109.943 213.963 129.925 228.193 144.565C230.109 146.536 230.109 149.722 228.193 151.694C213.963 166.334 205.201 186.316 205.201 208.344C205.201 225.847 210.733 242.057 220.143 255.323C222.494 258.637 220.262 263.593 216.199 263.593H39.5599C35.4969 263.593 33.2652 258.637 35.616 255.323C45.0265 242.057 50.5582 225.847 50.5582 208.344C50.5582 186.316 41.7956 166.334 27.5659 151.694Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.467 229.296C133.467 228.524 134.092 227.899 134.864 227.899H154.418C155.189 227.899 155.815 228.524 155.815 229.296V229.296C155.815 233.153 152.688 236.28 148.831 236.28H140.451C136.594 236.28 133.467 233.153 133.467 229.296V229.296Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.814 288.363V360.994",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1162 300.786V281.851C93.1162 279.965 94.6448 278.437 96.5304 278.437V278.437",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.689,
    cy: 212.574,
    r: 5.47048,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.245,
    cy: 212.574,
    r: 5.47048,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.515 208.5H127.084C131.113 208.5 134.378 211.766 134.378 215.794V215.794",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.069 208.5H155.639C159.667 208.5 162.933 211.766 162.933 215.794V215.794",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    width: 255.574,
    height: 359.39,
    fill: "#FF90E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 0,
    width: 257,
    height: 360
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.557 250.472H423.159C425.473 250.472 427.349 252.348 427.349 254.662V361.994H339.367V254.662C339.367 252.348 341.243 250.472 343.557 250.472Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.367,
    y: 339.082,
    width: 13.3695,
    height: 22.9117,
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.978,
    y: 339.082,
    width: 13.3695,
    height: 22.9117,
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.572 337.685L351.572 339.082L354.365 339.082L354.365 337.685L351.572 337.685ZM354.365 285.974C354.365 285.202 353.74 284.577 352.969 284.577C352.197 284.577 351.572 285.202 351.572 285.974L354.365 285.974ZM354.365 337.685L354.365 285.974L351.572 285.974L351.572 337.685L354.365 337.685Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15 285.973C415.15 285.202 414.524 284.577 413.753 284.577C412.982 284.577 412.356 285.202 412.356 285.973L415.15 285.973ZM412.356 337.685L412.356 339.081L415.15 339.081L415.15 337.685L412.356 337.685ZM412.356 285.973L412.356 337.685L415.15 337.685L415.15 285.973L412.356 285.973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.286 257.561C397.286 264.079 391.223 269.657 383.359 269.657C375.496 269.657 369.433 264.079 369.433 257.561C369.433 251.042 375.496 245.465 383.359 245.465C391.223 245.465 397.286 251.042 397.286 257.561Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.635 126.904C435.715 130.787 431.829 137.83 430.783 145.173C429.731 152.559 431.531 160.491 438.336 165.863C450.71 175.63 458.151 188.597 458.151 202.735C458.151 217.596 449.929 231.169 436.403 241.077C422.879 250.984 404.129 257.154 383.361 257.154C362.594 257.154 343.844 250.984 330.319 241.077C316.794 231.169 308.572 217.596 308.572 202.735C308.572 188.598 316.013 175.63 328.385 165.864C339.66 156.986 339.659 138.526 328.386 129.636C316.013 119.87 308.572 106.902 308.572 92.7646C308.572 77.9032 316.794 64.331 330.319 54.4229C343.844 44.5156 362.594 38.3456 383.361 38.3456C404.129 38.3456 422.879 44.5156 436.403 54.4229C449.929 64.331 458.151 77.9032 458.151 92.7646C458.151 99.9148 456.831 106.007 454.015 111.507C451.195 117.014 446.834 122.01 440.635 126.904Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.285 209.5L365.78 212.995C375.779 222.994 391.991 222.994 401.99 212.995L405.485 209.5",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.177 196.067C375.285 194.439 370.286 192.159 365.428 196.067",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.289 196.067C399.397 194.439 394.398 192.159 389.54 196.067",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 766,
    y: 0,
    width: 257,
    height: 360
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M823.477 60.1437H965.542C980.197 60.1437 992.077 72.0238 992.077 86.6787L992.077 220.743C992.077 235.398 980.197 247.278 965.542 247.278H915.282C900.627 247.278 888.747 235.398 888.747 220.743V179.278C888.747 177.992 887.705 176.95 886.419 176.95H823.477C808.822 176.95 796.942 165.07 796.942 150.415V86.6787C796.942 72.0238 808.822 60.1437 823.477 60.1437Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.281 261.044H965.541C980.196 261.044 992.076 272.924 992.076 287.579V361.993H888.746V287.579C888.746 272.924 900.626 261.044 915.281 261.044Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.402 287.539H888.28V321.863H821.173C817.831 321.863 815.121 319.154 815.121 315.811V250.071H857.006V286.143V287.539H858.402Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.875,
    y: 247.746,
    width: 27.0752,
    height: 12.8446,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 822.61,
    cy: 130.995,
    r: 7.48887,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 875.932,
    cy: 130.994,
    r: 7.48887,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 820.146,
    cy: 130.995,
    r: 6.42111,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 873.469,
    cy: 130.995,
    r: 6.42195,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 815.453,
    y: 146.951,
    width: 67.9687,
    height: 13.1965,
    rx: 6.59825,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.217 153.55L883.659 153.55",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.482 146.964L827.482 160.136",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.264 146.964L836.264 160.136",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.047 146.964L845.047 160.136",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.828 146.964L853.828 160.136",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.609 146.964L862.609 160.136",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.393 146.964L871.393 160.136",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.042 245.028V249.833H828.016C825.906 245.361 821.188 235.55 819.19 232.086C816.692 227.756 813.195 218.93 816.692 218.43C819.366 218.048 822.557 224.534 823.997 228.258C822.876 224.945 819.496 210.321 824.185 211.103C828.092 211.755 829.958 223.426 830.514 228.756C830.514 223.427 830.347 216.432 830.514 212.935C830.68 209.438 833.178 206.107 835.343 209.438C837.208 213.701 837.23 224.093 837.008 228.756C837.508 226.258 838.84 219.963 840.172 214.767C841.838 208.273 847.583 207.605 847.749 212.435C847.882 216.298 845.945 226.036 844.669 230.587C850.497 220.012 855.909 223.925 856.076 227.589C856.209 230.52 849.359 240.825 846.042 245.028Z",
    fill: "#FF90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.042 249.833V245.028C849.359 240.825 856.209 230.52 856.076 227.589C855.909 223.925 850.497 220.012 844.669 230.587C845.945 226.036 847.882 216.298 847.749 212.435C847.583 207.605 841.838 208.273 840.172 214.767C838.84 219.963 837.508 226.258 837.008 228.756C837.23 224.093 837.208 213.701 835.343 209.438C833.178 206.107 830.68 209.438 830.514 212.935C830.347 216.432 830.514 223.427 830.514 228.756C829.958 223.426 828.092 211.755 824.185 211.103C819.19 210.27 823.353 226.924 824.185 228.756C822.853 225.147 819.489 218.031 816.692 218.43C813.195 218.93 816.692 227.756 819.19 232.086C821.188 235.55 825.906 245.361 828.016 249.833H846.042Z",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.352 229.087C826.017 229.587 830.913 230.286 837.174 229.087M837.174 234.583C836.009 236.359 834.377 240.744 837.174 244.075",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    width: 255.574,
    height: 359.39,
    fill: "#FFC900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 511,
    y: 0,
    width: 256,
    height: 360
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1511_21950)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-47-inside-1_1511_21950",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.33 308.208C581.32 308.208 571.989 313.27 566.531 321.661L559.831 331.96C559.468 332.519 558.846 332.857 558.178 332.857H525.523C517.987 332.857 510.638 335.143 504.441 339.398V364.924H773.43V339.395C767.234 335.142 759.887 332.857 752.352 332.857H719.697C719.03 332.857 718.408 332.519 718.044 331.96L711.344 321.661C705.886 313.27 696.555 308.208 686.545 308.208H663.108V289.302H614.768V308.208H591.33Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591.33 308.208C581.32 308.208 571.989 313.27 566.531 321.661L559.831 331.96C559.468 332.519 558.846 332.857 558.178 332.857H525.523C517.987 332.857 510.638 335.143 504.441 339.398V364.924H773.43V339.395C767.234 335.142 759.887 332.857 752.352 332.857H719.697C719.03 332.857 718.408 332.519 718.044 331.96L711.344 321.661C705.886 313.27 696.555 308.208 686.545 308.208H663.108V289.302H614.768V308.208H591.33Z",
    fill: "#FF90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.531 321.661L568.872 323.184L568.872 323.184L566.531 321.661ZM559.831 331.96L557.49 330.437L557.49 330.437L559.831 331.96ZM504.441 339.398L502.86 337.096C502.102 337.617 501.648 338.478 501.648 339.398H504.441ZM504.441 364.924H501.648C501.648 366.467 502.899 367.717 504.441 367.717V364.924ZM773.43 364.924V367.717C774.972 367.717 776.223 366.467 776.223 364.924H773.43ZM773.43 339.395H776.223C776.223 338.475 775.77 337.614 775.011 337.093L773.43 339.395ZM718.044 331.96L715.703 333.483L715.703 333.483L718.044 331.96ZM711.344 321.661L713.686 320.138L713.686 320.138L711.344 321.661ZM663.108 308.208H660.315C660.315 309.751 661.565 311.001 663.108 311.001V308.208ZM663.108 289.302H665.901C665.901 287.76 664.651 286.509 663.108 286.509V289.302ZM614.768 289.302V286.509C613.225 286.509 611.974 287.76 611.974 289.302H614.768ZM614.768 308.208V311.001C616.31 311.001 617.561 309.751 617.561 308.208H614.768ZM568.872 323.184C573.815 315.585 582.265 311.001 591.33 311.001V305.415C580.375 305.415 570.163 310.954 564.19 320.138L568.872 323.184ZM562.173 333.483L568.872 323.184L564.19 320.138L557.49 330.437L562.173 333.483ZM558.178 335.65C559.791 335.65 561.294 334.835 562.173 333.483L557.49 330.437C557.641 330.204 557.9 330.064 558.178 330.064V335.65ZM525.523 335.65H558.178V330.064H525.523V335.65ZM506.023 341.701C511.755 337.765 518.552 335.65 525.523 335.65V330.064C517.422 330.064 509.522 332.521 502.86 337.096L506.023 341.701ZM507.235 364.924V339.398H501.648V364.924H507.235ZM773.43 362.131H504.441V367.717H773.43V362.131ZM776.223 364.924V339.395H770.637V364.924H776.223ZM752.352 335.65C759.322 335.65 766.118 337.764 771.849 341.698L775.011 337.093C768.35 332.52 760.452 330.064 752.352 330.064V335.65ZM719.697 335.65H752.352V330.064H719.697V335.65ZM715.703 333.483C716.582 334.835 718.085 335.65 719.697 335.65V330.064C719.975 330.064 720.234 330.204 720.385 330.437L715.703 333.483ZM709.003 323.184L715.703 333.483L720.385 330.437L713.686 320.138L709.003 323.184ZM686.545 311.001C695.61 311.001 704.06 315.585 709.003 323.184L713.686 320.138C707.712 310.954 697.5 305.415 686.545 305.415V311.001ZM663.108 311.001H686.545V305.415H663.108V311.001ZM660.315 289.302V308.208H665.901V289.302H660.315ZM614.768 292.096H663.108V286.509H614.768V292.096ZM617.561 308.208V289.302H611.974V308.208H617.561ZM591.33 311.001H614.768V305.415H591.33V311.001Z",
    fill: "black",
    mask: "url(#path-47-inside-1_1511_21950)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.363 291.527V101.493C573.363 101.236 573.572 101.027 573.829 101.027H606.461C606.637 101.027 606.799 101.127 606.878 101.284L637.038 161.605C637.211 161.952 637.707 161.947 637.874 161.598L666.716 101.292C666.794 101.13 666.957 101.027 667.136 101.027H701.543C701.801 101.027 702.009 101.236 702.009 101.493V291.527C702.009 291.784 701.801 291.992 701.543 291.992H573.829C573.572 291.992 573.363 291.784 573.363 291.527Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.576 218.099H663.444",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.846 218.989V291.992",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1022.3,
    width: 255.574,
    height: 359.39,
    fill: "#FF90E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1022,
    y: 0,
    width: 256,
    height: 360
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1022.3,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1088.36 289.153L1073.72 361.393C1073.67 361.681 1073.89 361.951 1074.18 361.951H1214.71C1215 361.951 1215.22 361.681 1215.16 361.393L1200.52 289.153C1200.5 289.015 1200.41 288.897 1200.28 288.832L1147.7 261.575C1147.63 261.541 1147.56 261.523 1147.48 261.523H1141.4C1141.33 261.523 1141.26 261.541 1141.19 261.575L1088.61 288.832C1088.48 288.897 1088.39 289.015 1088.36 289.153Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.78 325.048L1089.5 361.192",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.11 325.048L1199.39 361.193",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.46 69.6118L1149.05 98.7214L1127.1 68.2778L1126.01 116.309L1098.72 96.5383L1101.39 138.383L1054.45 117.036L1091.68 159.003L1049.72 173.921L1090.47 189.931L1062.82 203.637L1086.35 216.13L1059.3 234.324L1093.02 229.472L1077.73 248.636L1099.57 250.334L1074.58 278.23L1118.97 264.646L1115.09 304.914L1143.47 269.74L1165.31 303.459L1183.01 256.641L1205.09 276.532L1202.66 236.022L1248.27 256.641L1212.12 215.402L1250.45 203.031L1214.31 184.11L1231.29 171.738L1214.31 163.248L1240.75 139.96H1206.79L1246.57 105.514L1195.63 125.405L1216.01 81.2558L1178.65 102.603L1168.46 69.6118Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1132.68,
    cy: 217.342,
    r: 5.91981,
    fill: "white",
    stroke: "black",
    strokeWidth: 4.65528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1174.16,
    cy: 217.342,
    r: 5.91981,
    fill: "white",
    stroke: "black",
    strokeWidth: 4.65528,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.11 217.342H1168.1",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#FF90E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 359,
    width: 256,
    height: 360
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5352 570.562C30.5352 565.419 34.7036 561.251 39.8457 561.251H210.95C216.092 561.251 220.261 565.419 220.261 570.562V720.658H30.5352V570.562Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.724,
    y: 614.304,
    width: 35.6434,
    height: 106.354,
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.753 498.751C185.445 498.013 186.109 497.198 186.886 497.389C206.213 502.127 220.351 501.508 224.085 494.45C230.913 481.541 200.354 451.984 155.829 428.432C111.304 404.88 69.6741 396.252 62.8459 409.16C60.8773 412.882 62.0163 417.987 65.7014 423.934C66.1357 424.634 65.5405 425.552 64.7254 425.43C50.7216 423.318 40.6413 424.986 37.4689 430.983C32.5644 440.255 45.5057 457.353 68.4077 474.302C69.1169 474.827 68.7779 475.977 67.8986 476.049C53.865 477.196 43.2702 482.208 38.5187 491.191C29.536 508.173 44.0359 534.432 72.2866 556.94C72.9476 557.466 72.6385 558.562 71.8041 558.696C66.1552 559.602 62.0825 561.82 60.173 565.43C53.4306 578.176 76.211 603.45 111.055 621.881C145.898 640.312 179.61 644.92 186.353 632.174C190.598 624.149 183.14 611.157 168.337 598.035C167.665 597.439 168.126 596.296 169.023 596.33C187.924 597.033 202.483 591.986 208.296 580.997C217.034 564.478 203.551 539.18 176.806 517.096C176.177 516.577 176.456 515.53 177.253 515.356C181.601 514.408 184.697 512.53 186.213 509.663C187.767 506.727 187.53 503.005 185.753 498.751Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7441 545.2H201.348",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.5988,
    cy: 545.563,
    r: 6.6681,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.785,
    cy: 545.563,
    r: 6.6681,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.237,
    cy: 558.899,
    r: 5.81943,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7441 720.507V623.033",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.528 720.507V623.033",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#98282A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 359,
    width: 257,
    height: 360
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.601 411.139V608.774H279.121C285.767 604.227 293.463 594.433 293.463 583.589C293.463 572.745 296.261 555.955 322.146 545.111C348.031 534.267 351.529 523.424 360.624 498.588C369.719 473.752 383.662 462.407 399.102 460.81C409.246 459.76 440.728 453.114 449.823 435.624C458.322 419.28 478.039 413.471 487.601 411.139Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.156 639.044H474.566C480.993 639.044 486.204 644.255 486.204 650.682V720.124H280.518V650.682C280.518 644.255 285.728 639.044 292.156 639.044Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.141 664.631C301.004 673.818 298.704 683.995 298.704 694.705C298.704 703.711 300.331 712.34 303.309 720.321",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.977 664.631C467.114 673.818 469.414 683.995 469.414 694.705C469.414 703.711 467.788 712.34 464.81 720.321",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.447 608.775H369.329V638.561C361.98 640.366 355.496 643.576 350.455 647.762C358.471 655.204 370.818 659.972 384.668 659.972C397.649 659.972 409.31 655.784 417.322 649.131C412.429 644.589 405.924 641.043 398.447 638.969V608.775Z",
    fill: "#90A8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.329 608.774V607.378H367.933V608.774H369.329ZM398.447 608.774H399.844V607.378H398.447V608.774ZM369.329 638.561L369.663 639.917L370.726 639.656V638.561H369.329ZM350.455 647.762L349.563 646.687L348.339 647.703L349.505 648.785L350.455 647.762ZM417.322 649.131L418.214 650.205L419.438 649.189L418.272 648.107L417.322 649.131ZM398.447 638.969H397.051V640.031L398.074 640.314L398.447 638.969ZM369.329 610.171H398.447V607.378H369.329V610.171ZM370.726 638.561V608.774H367.933V638.561H370.726ZM351.347 648.836C356.208 644.8 362.496 641.678 369.663 639.917L368.996 637.205C361.464 639.055 354.783 642.353 349.563 646.687L351.347 648.836ZM384.668 658.575C371.12 658.575 359.128 653.908 351.405 646.738L349.505 648.785C357.814 656.499 370.516 661.369 384.668 661.369V658.575ZM416.43 648.056C408.697 654.477 397.363 658.575 384.668 658.575V661.369C397.936 661.369 409.923 657.09 418.214 650.205L416.43 648.056ZM398.074 640.314C405.362 642.336 411.662 645.782 416.372 650.154L418.272 648.107C413.197 643.395 406.485 639.749 398.821 637.623L398.074 640.314ZM397.051 608.774V638.969H399.844V608.774H397.051Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417.321 649.13C409.309 655.783 397.649 659.972 384.668 659.972C370.818 659.972 358.47 655.203 350.455 647.761C343.554 653.491 339.36 661.048 339.36 669.331C339.36 687.231 358.947 701.742 383.108 701.742C407.269 701.742 426.856 687.231 426.856 669.331C426.856 661.692 423.289 654.67 417.321 649.13Z",
    fill: "#98282A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.321 649.13L418.272 648.107L417.373 647.272L416.429 648.056L417.321 649.13ZM350.455 647.761L351.405 646.738L350.506 645.903L349.562 646.687L350.455 647.761ZM416.429 648.056C408.697 654.476 397.363 658.575 384.668 658.575V661.368C397.935 661.368 409.922 657.09 418.214 650.205L416.429 648.056ZM384.668 658.575C371.12 658.575 359.128 653.907 351.405 646.738L349.504 648.785C357.813 656.499 370.516 661.368 384.668 661.368V658.575ZM340.757 669.331C340.757 661.55 344.692 654.361 351.347 648.836L349.562 646.687C342.416 652.62 337.964 660.546 337.964 669.331H340.757ZM383.108 700.345C371.296 700.345 360.658 696.796 353.005 691.127C345.352 685.457 340.757 677.735 340.757 669.331H337.964C337.964 678.826 343.162 687.31 351.342 693.371C359.523 699.432 370.758 703.138 383.108 703.138V700.345ZM425.459 669.331C425.459 677.735 420.864 685.457 413.211 691.127C405.558 696.796 394.92 700.345 383.108 700.345V703.138C395.458 703.138 406.693 699.432 414.874 693.371C423.054 687.31 428.252 678.826 428.252 669.331H425.459ZM416.371 650.154C422.112 655.483 425.459 662.153 425.459 669.331H428.252C428.252 661.231 424.466 653.857 418.272 648.107L416.371 650.154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.806,
    cy: 544.148,
    r: 4.43859,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.962,
    cy: 544.148,
    r: 4.43859,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.851 560.782H396.559",
    stroke: "black",
    strokeWidth: 3.25869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 511,
    y: 359,
    width: 256,
    height: 360
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M766.815 625.483V724.321H511.057V630.272C539.406 613.397 574.375 601.851 612.837 597.83V486.481H673.527V597.83C708.233 601.458 740.094 611.214 766.815 625.483Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 629.559,
    cy: 518.519,
    r: 5.93605,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 656.182,
    cy: 518.519,
    r: 5.93605,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.402 463.089H696.276C696.47 463.089 696.644 462.968 696.712 462.786L713.695 417.272C713.835 416.895 714.354 416.862 714.542 417.216L738.772 462.946C738.821 463.039 738.838 463.145 738.819 463.248L712.494 607.252C712.489 607.28 712.486 607.308 712.486 607.336V675.264C712.486 675.521 712.278 675.73 712.02 675.73H669.306C669.049 675.73 668.84 675.56 668.84 675.302V489.269C668.84 489.012 668.632 488.811 668.375 488.811H617.804C617.547 488.811 617.339 489.012 617.339 489.269V675.302C617.339 675.56 617.13 675.73 616.873 675.73H575.206C574.949 675.73 574.741 675.521 574.741 675.264V606.301C574.741 606.265 574.736 606.228 574.728 606.192L539.857 461.48C539.836 461.391 539.841 461.297 539.873 461.21L556.921 414.841C557.06 414.462 557.582 414.428 557.77 414.785L582.99 462.84C583.07 462.993 583.229 463.089 583.402 463.089Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#FFC900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 766,
    y: 359,
    width: 257,
    height: 360
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830.429 628.667C821.032 642.886 802.238 681.191 802.238 720.658H989.996C989.996 681.191 971.202 642.886 961.805 628.667H830.429Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.345 655.374C845.636 661.432 839.33 677.555 843.781 693.58C840.69 698.773 834.508 711.458 834.508 720.657",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.139 655.374C947.849 661.432 954.154 677.555 949.703 693.58C952.794 698.773 958.977 711.458 958.977 720.657",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900.599,
    cy: 632.977,
    r: 24.3392,
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.085 496.315C985.085 505.683 982.526 514.449 978.069 521.957C977.14 523.523 977.268 525.518 978.429 526.944C988.18 538.917 994.025 554.194 994.025 570.84C994.025 609.259 962.881 640.403 924.462 640.403C918.217 640.403 912.166 639.581 906.411 638.039C904.971 637.653 903.46 638.044 902.369 639C896.92 643.774 889.785 646.666 881.972 646.666C872.065 646.666 863.246 642.016 857.575 634.774C856.691 633.645 855.305 632.986 853.843 633.068C852.847 633.125 851.843 633.153 850.833 633.153C821.735 633.153 798.147 609.565 798.147 580.467C798.147 570.847 800.724 561.833 805.225 554.073C806.185 552.418 805.953 550.339 804.701 548.921C798.659 542.08 794.994 533.094 794.994 523.249C794.994 506.465 805.652 492.166 820.574 486.759C822.42 486.09 823.639 484.273 823.5 482.287C823.414 481.052 823.37 479.805 823.37 478.547C823.37 449.306 847.075 425.602 876.315 425.602C887.835 425.602 898.491 429.28 907.18 435.525C909.028 436.853 911.534 436.526 913.069 434.976C917.557 430.446 923.778 427.642 930.656 427.642C942.873 427.642 953.025 436.494 955.045 448.133C955.283 449.504 956.139 450.729 957.421 451.376C973.834 459.665 985.085 476.677 985.085 496.315Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 878.278,
    cy: 587.957,
    r: 12.2407,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.334,
    cy: 587.957,
    r: 12.2407,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.515 605.026C912.83 610.355 908.276 614.474 902.76 614.474C897.244 614.474 892.69 610.355 892.005 605.026H913.515Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1022.3,
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1022,
    y: 359,
    width: 256,
    height: 360
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1022.3,
    y: 359.39,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1217.91 456.47H1082.26L1098.87 484.155V631.231H1217.91V456.47Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.68 586.934V581.744H1217.21",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.25 595.241V570.67H1153.54V595.241H1118.25Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1168.77 595.241V570.67H1204.07V595.241H1168.77Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.51 724.321V631.231H1174.65C1187.46 638.844 1194.9 646.458 1195.42 660.3C1195.83 671.374 1186.36 682.909 1181.58 687.293C1195.42 699.474 1197.26 717.054 1196.46 724.321H1125.51Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.7 724.321V647.495",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#FFC900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 718,
    width: 256,
    height: 361
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.616 1002.54V1079.64H178.647V998.298C178.647 997.237 172.812 982.207 139.921 982.207C113.609 982.207 106.088 995.764 105.616 1002.54Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.823 1079.82V1012.98",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.971 1079.82V1012.98",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.903 986.981C133.615 991.461 142.079 997.733 154.245 986.981C143.431 983.814 134.178 985.662 130.903 986.981Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.738 788.931C74.9181 792.326 65.7701 819.817 65.2986 833.139C60.9256 850.795 51.8594 857.541 39.1276 869.566C26.3959 881.59 26.7495 906.347 39.1276 917.664C51.4022 928.886 57.4169 939.413 61.655 946.831L61.762 947.018C66.0059 954.445 60.701 977.433 72.0182 989.104C83.3354 1000.77 102.079 999.36 125.067 989.104C148.056 978.847 165.739 992.64 177.056 995.116C188.373 997.591 202.873 1000.07 218.788 974.25C234.703 948.432 219.495 910.591 214.544 898.566C209.593 886.542 208.532 864.968 214.544 837.029C220.556 809.09 199.69 797.065 173.166 796.711C146.641 796.358 148.763 784.687 107.738 788.931Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.981 928.097C115.106 925.68 123.193 922.297 130.549 928.097",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.2749,
    cy: 894.499,
    r: 25.6586,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.665,
    cy: 894.499,
    r: 25.6586,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.2742,
    cy: 894.499,
    r: 20.5125,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.666,
    cy: 894.499,
    r: 20.5125,
    fill: "black"
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 718,
    width: 257,
    height: 361
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.265 1024.49V997.148H344.255V1014.27L387.619 981.957L401.571 996.375C403.252 998.111 404.191 1000.43 404.191 1002.85V1081.39H367.456V1016.21L341.816 1033.75C334.372 1038.84 324.265 1033.51 324.265 1024.49Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.255 1014.14V1018.14",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.362,
    cy: 895.745,
    r: 98.8754,
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.632 927.881C337.237 926.694 335.211 926.797 333.925 928.189C333.815 928.309 333.712 928.436 333.618 928.569C332.352 928.053 330.869 928.347 329.85 929.45C329.751 929.557 329.659 929.67 329.573 929.788C328.291 928.673 326.413 928.759 325.224 930.047C324.611 930.71 324.268 931.609 324.268 932.546V995.712C324.268 996.619 324.947 997.355 325.785 997.355H343.251C344.089 997.355 344.768 996.619 344.768 995.712V965.914L349.274 958.414C351.244 955.135 349.071 950.797 345.458 950.797H344.303V931.216C344.303 930.161 343.916 929.15 343.227 928.405C341.979 927.053 340.055 926.878 338.632 927.881Z",
    fill: "#FF90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.787 942.322C330.306 941.309 334.477 939.891 339.007 942.322",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.542 951.713V929.76C343.542 929.112 343.284 928.491 342.826 928.033V928.033C341.873 927.079 340.326 927.079 339.373 928.033V928.033C338.915 928.491 338.657 929.112 338.657 929.76V942.081",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.656 928.484L337.98 927.808C337.078 926.906 335.615 926.906 334.713 927.808V927.808C334.28 928.241 334.036 928.829 334.036 929.441V940.365",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.036 929.804L333.36 929.127C332.458 928.225 330.995 928.225 330.093 929.127V929.127C329.659 929.56 329.416 930.148 329.416 930.761V942.213",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 383.362,
    cy: 895.746,
    r: 22.0456,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.362 873.7V797.135",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.412 901.554C378.304 903.182 383.303 905.462 388.161 901.554",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.411,
    cy: 896.142,
    r: 1.9142,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388.16,
    cy: 896.142,
    r: 1.91441,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.284 931.389L327.523 929.628C326.819 928.923 325.677 928.923 324.972 929.628V929.628C324.521 930.079 324.268 930.691 324.268 931.329V997.287H344.069V965.579L349.455 957.298C350.944 955.01 349.302 951.982 346.571 951.982H339.374C336.921 951.982 335.327 954.562 336.423 956.755C336.902 957.713 337.881 958.318 338.952 958.318H340.901",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.604 953.698C329.768 955.767 328.597 960.774 330.604 964.259",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#FFC900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 511,
    y: 718,
    width: 256,
    height: 361
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.131 969.253H678.733C681.047 969.253 682.923 971.128 682.923 973.442V1080.77H594.942V973.442C594.942 971.128 596.817 969.253 599.131 969.253Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594.942,
    y: 1057.86,
    width: 13.3695,
    height: 22.9117,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 669.553,
    y: 1057.86,
    width: 13.3695,
    height: 22.9117,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.146 1056.47L607.146 1057.86L609.94 1057.86L609.94 1056.47L607.146 1056.47ZM609.94 1004.75C609.94 1003.98 609.314 1003.36 608.543 1003.36C607.772 1003.36 607.146 1003.98 607.146 1004.75L609.94 1004.75ZM609.94 1056.47L609.94 1004.75L607.146 1004.75L607.146 1056.47L609.94 1056.47Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.723 1004.75C670.723 1003.98 670.097 1003.36 669.326 1003.36C668.555 1003.36 667.93 1003.98 667.93 1004.75L670.723 1004.75ZM667.93 1056.46L667.93 1057.86L670.723 1057.86L670.723 1056.46L667.93 1056.46ZM667.93 1004.75L667.93 1056.46L670.723 1056.46L670.723 1004.75L667.93 1004.75Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.861 976.341C652.861 982.86 646.798 988.437 638.935 988.437C631.071 988.437 625.008 982.86 625.008 976.341C625.008 969.822 631.071 964.245 638.935 964.245C646.798 964.245 652.861 969.822 652.861 976.341Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.925 846.892C688.004 851.437 685.229 858.697 685.288 865.83C685.347 872.959 688.236 880.168 693.911 884.643C706.284 894.41 713.725 907.378 713.725 921.515C713.725 936.376 705.503 949.949 691.978 959.857C678.453 969.764 659.703 975.934 638.936 975.934C618.168 975.934 599.418 969.764 585.894 959.857C572.368 949.949 564.147 936.376 564.147 921.515C564.147 907.378 571.587 894.411 583.96 884.644C595.234 875.767 595.233 857.307 583.96 848.416C571.587 838.65 564.147 825.682 564.147 811.545C564.147 796.683 572.368 783.111 585.894 773.203C599.418 763.296 618.168 757.126 638.936 757.126C659.703 757.126 678.453 763.296 691.978 773.203C705.503 783.111 713.725 796.683 713.725 811.545C713.725 825.631 705.435 838.057 693.925 846.892Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 609.561,
    cy: 930.856,
    r: 2.57506,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 668.307,
    cy: 930.855,
    r: 2.57506,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.893 942.809H669.97",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#FF90E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 766,
    y: 718,
    width: 257,
    height: 361
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1511_21950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 885.688,
    y: 923.807,
    width: 63.1916,
    height: 156.319,
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.835 805.628C823.752 841.787 800.882 894.13 815.374 910.348C832.371 929.369 858.916 894.761 863.835 900.236C871.624 908.888 807.078 956.901 825.544 986.897C855.341 1035.28 1012.77 900.153 971.027 815.018C949.7 771.517 898.078 774.752 863.835 805.628Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.67 853.621L963.982 873.169L959.006 854.867",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 918.139,
    cy: 842.072,
    r: 12.7931,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 958.473,
    cy: 842.072,
    r: 12.7931,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 915.34,
    cy: 844.871,
    r: 3.95362,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 955.674,
    cy: 844.871,
    r: 3.95362,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.301 1080.17V1004.48",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1022.3,
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1022,
    y: 718,
    width: 256,
    height: 361
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1022.3,
    y: 718.78,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1151.42 1028.64C1181.57 1028.64 1206.01 1015.38 1206.01 999.012C1206.01 998.99 1206.01 998.968 1206.01 998.946C1206.01 998.682 1206.22 998.464 1206.48 998.464H1217.1C1217.17 998.464 1217.23 998.477 1217.29 998.504C1232.08 1005.21 1261.77 1030.54 1263.31 1078.69C1263.31 1078.95 1263.1 1079.17 1262.84 1079.17H1037.28C1037.02 1079.17 1036.81 1078.95 1036.82 1078.69C1038.35 1030.54 1068.04 1005.21 1082.83 998.504C1082.89 998.477 1082.95 998.464 1083.02 998.464H1096.35C1096.61 998.464 1096.82 998.682 1096.82 998.946C1096.82 998.968 1096.82 998.99 1096.82 999.012C1096.82 1015.38 1121.26 1028.64 1151.42 1028.64Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.5 1036.1L1258.11 958.112C1257.83 954.777 1256.59 948.108 1253.87 948.108C1251.16 948.108 1249.01 960.881 1248.28 967.267C1247.83 961.051 1246.77 948.278 1246.16 946.921C1245.4 945.226 1243.7 946.412 1243.19 948.956C1242.78 950.99 1241.04 962.011 1240.22 967.267C1239.6 961.107 1238.16 948.532 1237.34 947.514C1236.33 946.243 1234.8 946.752 1234.46 948.956C1234.19 950.719 1233.78 961.898 1233.61 967.267C1232.6 962.463 1230.14 952.465 1228.44 950.905C1226.32 948.956 1224.54 950.821 1224.8 953.449C1225 955.551 1226.29 969.641 1226.92 976.423C1224.99 975.547 1220.76 973.795 1219.2 973.795C1217.25 973.795 1217.51 977.016 1219.2 979.39C1220.56 981.289 1224.91 984.929 1226.92 986.511L1230 1036.1H1261.5Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1070.71 776.014C1107.06 770.859 1142.38 792.629 1155.49 804.159C1168.6 791.838 1202.42 768.96 1232.8 776.014C1217.66 791.612 1193.06 833.729 1215.85 877.405C1225.88 898.022 1236.53 911.315 1240.6 915.384C1227.49 924.992 1201.54 951.871 1202.62 982.526H1155.49H1103.94C1106.11 955.127 1077.04 926.348 1062.23 915.384C1069.36 909.393 1086.24 889.409 1096.82 857.398C1107.4 825.387 1083.82 789.804 1070.71 776.014Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1171.17,
    cy: 925.754,
    r: 3.24892,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1130.14,
    cy: 925.754,
    r: 3.24892,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.14 947.439L1171.17 947.439",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.25 976.592C1229.23 977.213 1233.45 978.783 1236.74 978.414C1241.28 977.906 1246.92 981.17 1248.11 984.221",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.5 1036.1L1263.37 1079.17H1232.68L1230 1036.1H1261.5Z",
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.42 1028.65C1181.57 1028.65 1206.01 1015.38 1206.01 999.014C1206.01 998.831 1206.01 998.649 1206 998.467H1175.83L1170.75 982.527H1129.38L1124.29 998.467H1096.83C1096.83 998.649 1096.82 998.831 1096.82 999.014C1096.82 1015.38 1121.27 1028.65 1151.42 1028.65Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1078,
    width: 256,
    height: 360
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3018 1377.17C92.3018 1372.68 93.9227 1368.34 96.8663 1364.96L127.687 1329.48L158.508 1364.96C161.451 1368.34 163.072 1372.68 163.072 1377.17V1438.56H92.3018V1377.17Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.633 1374.35C108.633 1371.62 109.232 1368.93 110.387 1366.46L127.686 1329.48L144.985 1366.46C146.141 1368.93 146.74 1371.62 146.74 1374.35V1438.56H108.633V1374.35Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.304 1264.06C188.094 1252.72 196.743 1236.41 196.743 1218.29C196.743 1184.05 165.871 1156.29 127.788 1156.29C89.7045 1156.29 58.832 1184.05 58.832 1218.29C58.832 1236.41 67.4815 1252.72 81.2716 1264.06C67.4815 1275.39 58.832 1291.7 58.832 1309.82C58.832 1344.07 89.7045 1371.82 127.788 1371.82C165.871 1371.82 196.743 1344.07 196.743 1309.82C196.743 1291.7 188.094 1275.39 174.304 1264.06Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.788,
    cy: 1263.9,
    r: 26.9673,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.788,
    cy: 1263.3,
    r: 7.15781,
    fill: "black"
  }))), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#FFC900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 1078,
    width: 257,
    height: 360
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.045 1359.52C289.81 1390.01 279.967 1424.65 279.699 1438.16H478.31C480.877 1402.53 459.853 1370.88 449.02 1359.52H327.045Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.093 1324.01C482.562 1330.27 485.481 1337.89 485.757 1340.92V1359.92H279.699C272.878 1311.97 295.949 1299.73 311.998 1286.09C328.048 1272.45 320.825 1253.59 304.375 1259.61C287.202 1265.39 280.769 1286.76 279.699 1296.72C274.082 1289.3 265.656 1273.65 275.486 1247.57C285.316 1221.49 312.801 1216.68 322.23 1214.07C331.659 1211.46 336.273 1194.41 323.835 1186.99C300.242 1175.11 285.383 1192.87 280.903 1203.24C266.659 1173.95 294.143 1143.05 321.226 1157.9C348.31 1172.74 349.112 1167.13 367.569 1147.06C386.026 1127 409.097 1149.07 416.319 1154.49C423.541 1159.9 434.775 1156.49 433.572 1145.06C432.127 1128.21 413.309 1125.06 404.081 1125.6C483.926 1112.76 456.643 1174.95 453.232 1182.57C449.822 1190.2 451.025 1202.84 461.859 1200.43C488.019 1194.49 483.057 1168.66 477.306 1156.49C501.38 1181.77 484.127 1206.65 475.701 1215.27C467.392 1223.78 468.057 1234.04 468.462 1240.29L468.479 1240.55C468.88 1246.77 468.68 1255.2 482.322 1262.02C495.963 1268.84 495.763 1277.87 495.763 1281.88C495.763 1285.89 493.957 1293.91 481.118 1298.73C468.278 1303.54 463.263 1308.96 463.263 1312.57C463.263 1314.78 461.257 1316.18 473.093 1324.01Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.757 1360.47C485.757 1360.29 485.757 1360.11 485.757 1359.92M485.757 1359.92C485.757 1353.24 485.757 1340.92 485.757 1340.92C485.481 1337.89 482.562 1330.27 473.093 1324.01C461.257 1316.18 463.263 1314.78 463.263 1312.57C463.263 1308.96 468.278 1303.54 481.118 1298.73C493.957 1293.91 495.763 1285.89 495.763 1281.88C495.763 1277.87 495.963 1268.84 482.322 1262.02C468.68 1255.2 468.88 1246.77 468.479 1240.55C468.078 1234.33 467.275 1223.9 475.701 1215.27C484.127 1206.65 501.38 1181.77 477.306 1156.49C483.057 1168.66 488.019 1194.49 461.859 1200.43C451.025 1202.84 449.822 1190.2 453.232 1182.57C456.643 1174.95 483.926 1112.76 404.081 1125.6C413.309 1125.06 432.127 1128.21 433.572 1145.06C434.775 1156.49 423.541 1159.9 416.319 1154.49C409.097 1149.07 386.026 1127 367.569 1147.06C349.112 1167.13 348.31 1172.74 321.226 1157.9C294.143 1143.05 266.659 1173.95 280.903 1203.24C285.383 1192.87 300.242 1175.11 323.835 1186.99C336.273 1194.41 331.659 1211.46 322.23 1214.07C312.801 1216.68 285.316 1221.49 275.486 1247.57C265.656 1273.65 274.082 1289.3 279.699 1296.72C280.769 1286.76 287.202 1265.39 304.375 1259.61C320.825 1253.59 328.048 1272.45 311.998 1286.09C295.949 1299.73 272.878 1311.97 279.699 1359.92H485.757Z",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.836 1423.49L406.548 1355.24C407.042 1353.82 407.426 1352.33 407.294 1350.84C406.987 1347.34 405.136 1343.39 399.267 1345.47C400.203 1341.73 402.035 1333.84 401.875 1332.23C401.674 1330.23 397.863 1326.42 394.653 1332.23C393.917 1329.63 391.363 1325.61 387.029 1330.43C385.692 1328.22 382.214 1325.13 379.005 1330.43C377.667 1327.35 374.15 1323.41 370.779 1332.23C368.355 1338.58 354.506 1374.38 342.343 1405.79L382.836 1423.49Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.836 1423.49L377.6 1438.56H329.652C333.106 1429.64 337.596 1418.05 342.342 1405.79L382.836 1423.49Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.694,
    cy: 1270.99,
    r: 6.11884,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.893,
    cy: 1270.99,
    r: 6.11884,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.693 1288.12L407.893 1288.12",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.205 1329.93L370.979 1360.72",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.028 1330.33L378.603 1362.32",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.154 1331.33L385.725 1363.73",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.568 1345.37C396.659 1354.07 390.62 1371.83 389.737 1373.36C388.634 1375.27 387.731 1378.58 384.822 1378.98C381.913 1379.38 373.086 1382.59 368.271 1391.41",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.211 1438.56L325.038 1402.05",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.232 1438.16L446.813 1405.06",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }))), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1022.3,
    y: 1437.55,
    width: 255.574,
    height: 359.39,
    fill: "#FFC900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1022,
    y: 1437,
    width: 256,
    height: 360
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1022.3 1437.55H1277.87V1796.94H1150.08H1022.3V1437.55Z",
    fill: "#23A094"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1085.08 1660.92V1671.56H1035.33V1626.42C1035.33 1604.05 1038.94 1601.74 1041.35 1601.74C1043.73 1601.74 1044.84 1607.64 1045.15 1609.32L1045.16 1609.36C1045.4 1610.65 1046.53 1623.88 1047.07 1630.33C1047.37 1607.66 1051.18 1595.12 1054.69 1595.12C1057.5 1595.12 1058.67 1600.81 1058.9 1603.65L1060.21 1626.42C1060.21 1604.25 1064.72 1595.82 1067.13 1595.82C1069.06 1595.82 1070.21 1601.04 1070.54 1603.65L1071.24 1624.61C1071.64 1615.85 1073.33 1598.33 1076.86 1598.33C1080.39 1598.33 1081.41 1608.5 1081.47 1613.58V1638.37C1081.47 1638.8 1082.03 1639.01 1082.33 1638.7C1084.34 1636.61 1088.06 1633.52 1091.91 1632.84C1097.52 1631.83 1096.92 1638.25 1096.52 1642.47C1096.2 1645.84 1088.69 1656.18 1085.08 1660.92Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.56 1632.03C1048.31 1629.96 1059.57 1625.57 1074.65 1624.61",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.67 1638.86C1076.86 1638.86 1065.91 1640.74 1060.61 1648.28",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.01 1649.49C1252.8 1675.17 1231.13 1707.53 1220.7 1720.51H1107.96C1107.42 1710.48 1111.41 1687.2 1131.63 1674.36C1156.91 1658.32 1177.37 1645.07 1184.19 1625.01C1191.01 1604.95 1156.91 1597.73 1137.65 1597.73C1118.39 1597.73 1069.04 1601.74 1058.2 1566.83C1049.54 1538.91 1072.51 1522.3 1085.09 1517.48C1120.66 1505.85 1194.38 1481.85 1204.65 1478.96C1217.49 1475.35 1230.73 1475.35 1237.96 1489.4C1245.18 1503.44 1234.75 1521.9 1230.73 1528.32C1226.72 1534.74 1209.87 1551.19 1234.75 1570.04C1259.62 1588.9 1260.02 1617.39 1256.01 1649.49Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1099.43,
    cy: 1537.04,
    r: 5.31669,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.84 1729.82V1798.94H1096.72V1771.86H1086.54C1058.26 1771.86 1035.33 1748.94 1035.33 1720.66V1671.56H1085.08V1701.88C1085.08 1712.17 1093.42 1720.51 1103.71 1720.51H1255.53C1260.67 1720.51 1264.84 1724.67 1264.84 1729.82Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.71 1797.95L1224.71 1772.97",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.11 1753.98L1138.3 1721.22C1138.11 1720.91 1138.33 1720.51 1138.69 1720.51H1179.35C1179.71 1720.51 1179.94 1720.9 1179.75 1721.21L1159.9 1753.97C1159.72 1754.27 1159.3 1754.27 1159.11 1753.98Z",
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }))), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 511,
    y: 1078,
    width: 256,
    height: 360
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.888 1335.9V1194.91C717.888 1194.74 717.799 1194.59 717.654 1194.51L631.317 1144.94C631.142 1144.83 630.922 1144.86 630.773 1144.99L524.849 1240.99C524.713 1241.11 524.662 1241.3 524.719 1241.48L555.691 1336.05C555.754 1336.24 555.933 1336.37 556.134 1336.37H717.422C717.679 1336.37 717.888 1336.16 717.888 1335.9Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 690.873,
    cy: 1255.74,
    r: 8.1683,
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.882 1261.15C753.079 1261.33 753.079 1261.64 752.882 1261.83L718.672 1293.79C718.374 1294.06 717.889 1293.85 717.889 1293.45L717.889 1229.53C717.889 1229.12 718.374 1228.91 718.672 1229.19L752.882 1261.15Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.496,
    y: 1336.37,
    width: 73.0822,
    height: 102.191,
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 596.496,
    y: 1363.05,
    width: 25.8543,
    height: 13.7334,
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 622.35,
    y: 1369.91,
    width: 47.2279,
    height: 13.7335,
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.746 1357.81C623.746 1357.04 623.121 1356.41 622.35 1356.41C621.578 1356.41 620.953 1357.04 620.953 1357.81L623.746 1357.81ZM620.953 1437.39L620.953 1438.79L623.746 1438.79L623.746 1437.39L620.953 1437.39ZM620.953 1357.81L620.953 1437.39L623.746 1437.39L623.746 1357.81L620.953 1357.81Z",
    fill: "black"
  }))), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#98282A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 766,
    y: 1078,
    width: 257,
    height: 360
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M861.676 1371.38C861.676 1366.49 865.636 1362.53 870.521 1362.53H918.499C923.384 1362.53 927.344 1366.49 927.344 1371.38V1438.56H861.676V1371.38Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891.787,
    cy: 1353.73,
    r: 16.3089,
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.585 1264.27L970.585 1264.28C970.858 1307.62 965.433 1332.39 953.136 1346.39C940.906 1360.32 921.542 1363.96 892.675 1363.96C865.115 1363.96 846.817 1360.32 835.243 1346.42C823.579 1332.41 818.424 1307.62 818.424 1264.27C818.424 1220.76 823.339 1194.52 835.041 1179.12C846.636 1163.86 865.175 1158.93 893.591 1158.93C922.747 1158.93 941.653 1163.81 953.472 1179.05C965.396 1194.42 970.403 1220.65 970.585 1264.27Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.889 1383.65C910.889 1382.87 910.263 1382.25 909.492 1382.25C908.721 1382.25 908.096 1382.87 908.096 1383.65L910.889 1383.65ZM908.096 1437.39L908.096 1438.79L910.889 1438.79L910.889 1437.39L908.096 1437.39ZM908.096 1383.65L908.096 1437.39L910.889 1437.39L910.889 1383.65L908.096 1383.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 871.256,
    cy: 1335.74,
    r: 5.48818,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 889.021,
    cy: 1335.74,
    r: 5.48818,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.098,
    y: 1345.78,
    width: 21.0583,
    height: 3.60297,
    rx: 1.80148,
    fill: "black"
  }))), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    y: 1437.56,
    width: 255.574,
    height: 359.39,
    fill: "#FFC900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1437,
    width: 256,
    height: 360
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    y: 1437.56,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8613 1712.5V1484.51C33.8613 1484.08 34.4074 1483.88 34.6855 1484.22L91.3052 1552.63C91.4418 1552.8 91.6735 1552.85 91.8664 1552.76L234.023 1484.05C234.461 1483.83 234.89 1484.35 234.6 1484.74L140.301 1611.74C140.173 1611.91 140.18 1612.15 140.318 1612.31L224.034 1712.2C224.288 1712.51 224.072 1712.97 223.677 1712.97H34.3269C34.0698 1712.97 33.8613 1712.76 33.8613 1712.5Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.48887,
    transform: "matrix(-1 0 0 1 143.95 1671.42)",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    r: 7.48887,
    transform: "matrix(-1 0 0 1 113.728 1671.42)",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.42111,
    transform: "matrix(-1 0 0 1 146.414 1671.42)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.42195,
    transform: "matrix(-1 0 0 1 116.191 1671.43)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.528 1754.39C179.301 1754.39 179.108 1754.55 179.063 1754.78C176.59 1766.91 153.897 1776.41 126.269 1776.41C98.6399 1776.41 75.9472 1766.91 73.4747 1754.78C73.4293 1754.55 73.2364 1754.39 73.009 1754.39H48.2927C40.3225 1754.39 33.8613 1760.85 33.8613 1768.82V1798.48C33.8613 1798.74 34.0698 1798.94 34.3269 1798.94H222.133C222.39 1798.94 222.599 1798.74 222.599 1798.48V1768.82C222.599 1760.85 216.138 1754.39 208.167 1754.39H179.528Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.585 1754.39C178.872 1754.39 179.092 1754.65 179.031 1754.93C176.4 1766.99 153.782 1776.41 126.269 1776.41C98.7561 1776.41 76.1381 1766.99 73.5073 1754.93C73.4459 1754.65 73.6655 1754.39 73.9534 1754.39H100.459C105.601 1754.39 109.77 1750.22 109.77 1745.08V1713.43C109.77 1713.18 109.978 1712.97 110.235 1712.97H145.948C146.205 1712.97 146.414 1713.18 146.414 1713.43V1745.08C146.414 1750.22 150.582 1754.39 155.724 1754.39H178.585Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2.79317
  }))), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 1437.56,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 255,
    y: 1437,
    width: 257,
    height: 360
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 1437.56,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.711 1716.17C374.711 1706.91 382.214 1699.41 391.47 1699.41H444.281V1797.94H374.711V1716.17Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.711,
    y: 1746.61,
    width: 18.3077,
    height: 31.4495,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.019,
    y: 1753.24,
    width: 51.2619,
    height: 34.1045,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.415 1720.08C394.415 1719.31 393.79 1718.69 393.019 1718.69C392.247 1718.69 391.622 1719.31 391.622 1720.08L394.415 1720.08ZM391.622 1796.82L391.622 1798.22L394.415 1798.22L394.415 1796.82L391.622 1796.82ZM391.622 1720.08L391.622 1796.82L394.415 1796.82L394.415 1720.08L391.622 1720.08Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.782 1585.04C416.931 1580.34 417.54 1575.43 417.54 1570.38C417.54 1536.1 389.465 1508.3 354.832 1508.3C320.199 1508.3 292.123 1536.1 292.123 1570.38C292.123 1603.38 318.12 1630.36 350.941 1632.35C349.791 1637.05 349.182 1641.96 349.182 1647.01C349.182 1681.29 377.258 1709.09 411.891 1709.09C446.524 1709.09 474.6 1681.29 474.6 1647.01C474.6 1614.01 448.603 1587.03 415.782 1585.04Z",
    fill: "#FF90E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.782 1585.04L414.426 1584.71L414.028 1586.34L415.698 1586.44L415.782 1585.04ZM350.941 1632.35L352.297 1632.68L352.695 1631.05L351.025 1630.95L350.941 1632.35ZM416.144 1570.38C416.144 1575.32 415.549 1580.12 414.426 1584.71L417.139 1585.37C418.314 1580.57 418.937 1575.55 418.937 1570.38H416.144ZM354.832 1509.7C388.707 1509.7 416.144 1536.88 416.144 1570.38H418.937C418.937 1535.31 390.223 1506.91 354.832 1506.91V1509.7ZM293.52 1570.38C293.52 1536.88 320.957 1509.7 354.832 1509.7V1506.91C319.441 1506.91 290.726 1535.31 290.726 1570.38H293.52ZM351.025 1630.95C318.925 1629.01 293.52 1602.62 293.52 1570.38H290.726C290.726 1604.13 317.315 1631.71 350.856 1633.74L351.025 1630.95ZM350.579 1647.01C350.579 1642.07 351.174 1637.27 352.297 1632.68L349.584 1632.01C348.408 1636.82 347.786 1641.84 347.786 1647.01H350.579ZM411.891 1707.69C378.016 1707.69 350.579 1680.51 350.579 1647.01H347.786C347.786 1682.08 376.5 1710.48 411.891 1710.48V1707.69ZM473.203 1647.01C473.203 1680.51 445.766 1707.69 411.891 1707.69V1710.48C447.282 1710.48 475.996 1682.08 475.996 1647.01H473.203ZM415.698 1586.44C447.798 1588.38 473.203 1614.77 473.203 1647.01H475.996C475.996 1613.26 449.408 1585.68 415.867 1583.65L415.698 1586.44Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 433.1,
    cy: 1637.76,
    rx: 10.6028,
    ry: 4.93725,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.112,
    cy: 1626.5,
    r: 1.61726,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 451.397,
    cy: 1626.5,
    r: 1.61726,
    fill: "black"
  }))), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 1437.56,
    width: 255.574,
    height: 359.39,
    fill: "#FF90E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 511,
    y: 1437,
    width: 256,
    height: 360
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 1437.56,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_1511_21950)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.543 1534.36C630.543 1530.25 633.877 1526.91 637.991 1526.91H696.549C700.662 1526.91 703.997 1530.25 703.997 1534.36V1588.88C703.997 1592.99 700.662 1596.33 696.549 1596.33H691.376V1634.95H704.926C708.526 1634.95 711.443 1637.87 711.443 1641.46V1708.07C711.443 1711.67 708.526 1714.59 704.926 1714.59H601.973C598.374 1714.59 595.456 1711.67 595.456 1708.07V1666H575.738C570.596 1666 566.428 1661.83 566.428 1656.69V1549.6C566.428 1544.46 570.596 1540.29 575.738 1540.29H630.543V1534.36Z",
    fill: "#23A094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.376 1596.33V1594.93H689.979V1596.33H691.376ZM691.376 1634.95H689.979V1636.34H691.376V1634.95ZM595.456 1666H596.853V1664.6H595.456V1666ZM630.543 1540.29V1541.69H631.939V1540.29H630.543ZM637.991 1525.51C633.106 1525.51 629.146 1529.47 629.146 1534.36H631.939C631.939 1531.02 634.649 1528.31 637.991 1528.31V1525.51ZM696.549 1525.51H637.991V1528.31H696.549V1525.51ZM705.394 1534.36C705.394 1529.47 701.434 1525.51 696.549 1525.51V1528.31C699.891 1528.31 702.601 1531.02 702.601 1534.36H705.394ZM705.394 1588.88V1534.36H702.601V1588.88H705.394ZM696.549 1597.72C701.434 1597.72 705.394 1593.76 705.394 1588.88H702.601C702.601 1592.22 699.891 1594.93 696.549 1594.93V1597.72ZM691.376 1597.72H696.549V1594.93H691.376V1597.72ZM692.773 1634.95V1596.33H689.979V1634.95H692.773ZM691.376 1636.34H704.926V1633.55H691.376V1636.34ZM704.926 1636.34C707.754 1636.34 710.047 1638.64 710.047 1641.46H712.84C712.84 1637.09 709.297 1633.55 704.926 1633.55V1636.34ZM710.047 1641.46V1708.07H712.84V1641.46H710.047ZM710.047 1708.07C710.047 1710.9 707.754 1713.19 704.926 1713.19V1715.98C709.297 1715.98 712.84 1712.44 712.84 1708.07H710.047ZM704.926 1713.19H601.973V1715.98H704.926V1713.19ZM601.973 1713.19C599.145 1713.19 596.853 1710.9 596.853 1708.07H594.059C594.059 1712.44 597.603 1715.98 601.973 1715.98V1713.19ZM596.853 1708.07V1666H594.059V1708.07H596.853ZM575.738 1667.39H595.456V1664.6H575.738V1667.39ZM565.031 1656.69C565.031 1662.6 569.825 1667.39 575.738 1667.39V1664.6C571.368 1664.6 567.824 1661.06 567.824 1656.69H565.031ZM565.031 1549.6V1656.69H567.824V1549.6H565.031ZM575.738 1538.89C569.825 1538.89 565.031 1543.69 565.031 1549.6H567.824C567.824 1545.23 571.368 1541.69 575.738 1541.69V1538.89ZM630.543 1538.89H575.738V1541.69H630.543V1538.89ZM629.146 1534.36V1540.29H631.939V1534.36H629.146Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630,
    y: 1715,
    width: 51,
    height: 84,
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.992 1731.72V1797.94",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.641 1602.52L629.882 1602.52",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.695 1587.59L649.468 1587.59C652.039 1587.59 654.123 1589.67 654.123 1592.24L654.123 1593.02",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.695 1573.97L622.011 1573.97",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.616 1587.59C615.616 1590.26 612.653 1593 608.204 1593C603.754 1593 600.791 1590.26 600.791 1587.59C600.791 1584.91 603.754 1582.18 608.204 1582.18C612.653 1582.18 615.616 1584.91 615.616 1587.59Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.204,
    cy: 1573.97,
    rx: 8.80913,
    ry: 6.8097,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.733 1587.59C635.733 1590.26 632.77 1593 628.321 1593C623.871 1593 620.908 1590.26 620.908 1587.59C620.908 1584.91 623.871 1582.18 628.321 1582.18C632.77 1582.18 635.733 1584.91 635.733 1587.59Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 628.321,
    cy: 1573.97,
    rx: 8.80913,
    ry: 6.8097,
    fill: "black"
  }))), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 1437.56,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 766,
    y: 1437,
    width: 257,
    height: 360
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 1437.56,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_1511_21950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 892.965,
    y: 1680.65,
    width: 6.79061,
    height: 117.292,
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.59 1680.65H795.428L896.978 1643.61L993.59 1680.65Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 900,
    y: 1681,
    width: 82,
    height: 119,
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811,
    y: 1681,
    width: 82,
    height: 119,
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.377 1518.09L818.124 1610.55L822.158 1614.05L810.309 1650.54L896.025 1712.76L981.742 1650.54L969.893 1614.05L973.927 1610.55L943.674 1518.09H848.377Z",
    fill: "#98282A",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 833.426,
    y: 1614.3,
    width: 125.201,
    height: 10.9957,
    fill: "#90A8ED",
    stroke: "black",
    strokeWidth: 2.79317
  }))), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 1022.3,
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_1511_21950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1022,
    y: 1078,
    width: 256,
    height: 360
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1022.3,
    y: 1078.17,
    width: 255.574,
    height: 359.39,
    fill: "#23A094"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_1511_21950)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1096.79,
    y: 1323.63,
    width: 117.273,
    height: 114.923,
    fill: "#FF90E8",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1165.57,
    y: 1323.63,
    width: 6.19458,
    height: 114.923,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1194.59 1205.27C1195.44 1203.1 1195.91 1200.74 1195.91 1198.27C1195.91 1187.61 1187.21 1178.98 1176.48 1178.98C1165.75 1178.98 1157.05 1187.61 1157.05 1198.27C1157.05 1200.66 1157.49 1202.96 1158.3 1205.07H1131.75C1128.27 1196.21 1119.64 1189.93 1109.54 1189.93C1096.37 1189.93 1085.7 1200.61 1085.7 1213.78C1085.7 1223.13 1091.08 1231.23 1098.92 1235.13V1241.82H1067.84C1058.7 1241.82 1051.29 1249.23 1051.29 1258.37C1051.29 1267.51 1058.7 1274.93 1067.84 1274.93H1098.92V1286.04C1083.82 1287.89 1072.12 1300.76 1072.12 1316.36C1072.12 1333.24 1085.79 1346.91 1102.66 1346.91H1107.68C1122.05 1346.91 1134.1 1336.99 1137.36 1323.63H1187.42C1191.37 1331.77 1199.76 1337.39 1209.47 1337.39C1222.98 1337.39 1233.93 1326.52 1233.93 1313.1C1233.93 1302.63 1227.26 1293.71 1217.91 1290.29V1267.45H1231.79C1241.23 1267.45 1248.88 1259.8 1248.88 1250.36C1248.88 1240.92 1241.23 1233.27 1231.79 1233.27H1217.91V1231.61C1217.91 1218.05 1207.73 1206.86 1194.59 1205.27Z",
    fill: "#F1F333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1194.59 1205.27L1193.29 1204.76C1193.13 1205.16 1193.17 1205.61 1193.39 1205.98C1193.61 1206.35 1194 1206.6 1194.42 1206.65L1194.59 1205.27ZM1158.3 1205.07V1206.47C1158.76 1206.47 1159.19 1206.25 1159.45 1205.87C1159.71 1205.49 1159.77 1205.01 1159.6 1204.58L1158.3 1205.07ZM1131.75 1205.07L1130.45 1205.58C1130.66 1206.12 1131.17 1206.47 1131.75 1206.47V1205.07ZM1098.92 1235.13H1100.32C1100.32 1234.6 1100.02 1234.12 1099.55 1233.88L1098.92 1235.13ZM1098.92 1241.82V1243.21C1099.7 1243.21 1100.32 1242.59 1100.32 1241.82H1098.92ZM1098.92 1274.93H1100.32C1100.32 1274.15 1099.7 1273.53 1098.92 1273.53V1274.93ZM1098.92 1286.04L1099.09 1287.43C1099.79 1287.34 1100.32 1286.75 1100.32 1286.04H1098.92ZM1137.36 1323.63V1322.23C1136.72 1322.23 1136.16 1322.67 1136 1323.3L1137.36 1323.63ZM1187.42 1323.63L1188.68 1323.02C1188.44 1322.54 1187.96 1322.23 1187.42 1322.23V1323.63ZM1217.91 1290.29H1216.51C1216.51 1290.88 1216.88 1291.41 1217.43 1291.61L1217.91 1290.29ZM1217.91 1267.45V1266.05C1217.13 1266.05 1216.51 1266.68 1216.51 1267.45H1217.91ZM1217.91 1233.27H1216.51C1216.51 1234.04 1217.13 1234.67 1217.91 1234.67V1233.27ZM1194.51 1198.27C1194.51 1200.56 1194.08 1202.75 1193.29 1204.76L1195.89 1205.78C1196.81 1203.45 1197.31 1200.91 1197.31 1198.27H1194.51ZM1176.48 1180.37C1186.45 1180.37 1194.51 1188.39 1194.51 1198.27H1197.31C1197.31 1186.83 1187.97 1177.58 1176.48 1177.58V1180.37ZM1158.45 1198.27C1158.45 1188.39 1166.51 1180.37 1176.48 1180.37V1177.58C1164.99 1177.58 1155.66 1186.83 1155.66 1198.27H1158.45ZM1159.6 1204.58C1158.86 1202.62 1158.45 1200.49 1158.45 1198.27H1155.66C1155.66 1200.84 1156.13 1203.3 1156.99 1205.57L1159.6 1204.58ZM1131.75 1206.47H1158.3V1203.68H1131.75V1206.47ZM1109.54 1191.33C1119.04 1191.33 1127.17 1197.24 1130.45 1205.58L1133.05 1204.56C1129.37 1195.18 1120.23 1188.54 1109.54 1188.54V1191.33ZM1087.09 1213.78C1087.09 1201.38 1097.14 1191.33 1109.54 1191.33V1188.54C1095.6 1188.54 1084.3 1199.84 1084.3 1213.78H1087.09ZM1099.55 1233.88C1092.16 1230.21 1087.09 1222.58 1087.09 1213.78H1084.3C1084.3 1223.68 1090.01 1232.25 1098.3 1236.38L1099.55 1233.88ZM1100.32 1241.82V1235.13H1097.53V1241.82H1100.32ZM1067.84 1243.21H1098.92V1240.42H1067.84V1243.21ZM1052.69 1258.37C1052.69 1250 1059.47 1243.21 1067.84 1243.21V1240.42C1057.93 1240.42 1049.89 1248.46 1049.89 1258.37H1052.69ZM1067.84 1273.53C1059.47 1273.53 1052.69 1266.74 1052.69 1258.37H1049.89C1049.89 1268.29 1057.93 1276.32 1067.84 1276.32V1273.53ZM1098.92 1273.53H1067.84V1276.32H1098.92V1273.53ZM1100.32 1286.04V1274.93H1097.53V1286.04H1100.32ZM1073.51 1316.36C1073.51 1301.47 1084.68 1289.19 1099.09 1287.43L1098.76 1284.66C1082.96 1286.59 1070.72 1300.04 1070.72 1316.36H1073.51ZM1102.66 1345.52C1086.56 1345.52 1073.51 1332.46 1073.51 1316.36H1070.72C1070.72 1334.01 1085.02 1348.31 1102.66 1348.31V1345.52ZM1107.68 1345.52H1102.66V1348.31H1107.68V1345.52ZM1136 1323.3C1132.89 1336.05 1121.39 1345.52 1107.68 1345.52V1348.31C1122.71 1348.31 1135.31 1337.94 1138.72 1323.96L1136 1323.3ZM1187.42 1322.23H1137.36V1325.03H1187.42V1322.23ZM1209.47 1335.99C1200.31 1335.99 1192.4 1330.7 1188.68 1323.02L1186.16 1324.24C1190.34 1332.85 1199.21 1338.79 1209.47 1338.79V1335.99ZM1232.54 1313.1C1232.54 1325.74 1222.22 1335.99 1209.47 1335.99V1338.79C1223.74 1338.79 1235.33 1327.3 1235.33 1313.1H1232.54ZM1217.43 1291.61C1226.25 1294.83 1232.54 1303.24 1232.54 1313.1H1235.33C1235.33 1302.02 1228.27 1292.59 1218.38 1288.98L1217.43 1291.61ZM1216.51 1267.45V1290.29H1219.3V1267.45H1216.51ZM1231.79 1266.05H1217.91V1268.85H1231.79V1266.05ZM1247.48 1250.36C1247.48 1259.03 1240.46 1266.05 1231.79 1266.05V1268.85C1242 1268.85 1250.28 1260.57 1250.28 1250.36H1247.48ZM1231.79 1234.67C1240.46 1234.67 1247.48 1241.69 1247.48 1250.36H1250.28C1250.28 1240.15 1242 1231.88 1231.79 1231.88V1234.67ZM1217.91 1234.67H1231.79V1231.88H1217.91V1234.67ZM1216.51 1231.61V1233.27H1219.3V1231.61H1216.51ZM1194.42 1206.65C1206.87 1208.16 1216.51 1218.76 1216.51 1231.61H1219.3C1219.3 1217.33 1208.59 1205.56 1194.76 1203.88L1194.42 1206.65Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.33 1359.94L1127.33 1438.55",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.85 1357.59L1191.85 1438.55",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1330.25H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1339.1H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1347.94H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1356.79H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1365.63H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1374.48H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1383.32H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1392.17H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1401.01H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1409.86H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1418.7H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.77 1427.55H1165.57",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1180.97,
    cy: 1246.73,
    rx: 12.2626,
    ry: 12.176,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1135.9,
    cy: 1246.73,
    rx: 12.2626,
    ry: 12.176,
    fill: "white",
    stroke: "black",
    strokeWidth: 2.79317
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1180.04,
    cy: 1246.73,
    rx: 6.66894,
    ry: 6.62184,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.9 1268.94L1180.97 1268.94",
    stroke: "black",
    strokeWidth: 2.79317,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1136.83,
    cy: 1246.73,
    rx: 6.66888,
    ry: 6.62183,
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.574 0.00292969V359.39H0",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 359.393H255.574V718.78H0",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 718.783H255.574V1078.17H0",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1078.17H255.574V1437.56H0",
    stroke: "black",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1437.56H255.574V1796.94",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M255.574 0.00292969V359.39H511.148V0.00292969",
    stroke: "black",
    strokeWidth: 2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 359.393,
    width: 255.574,
    height: 359.387,
    stroke: "black",
    strokeWidth: 2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 718.783,
    width: 255.574,
    height: 359.387,
    stroke: "black",
    strokeWidth: 2
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 255.574,
    y: 1078.17,
    width: 255.574,
    height: 359.387,
    stroke: "black",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M511.148 1796.94V1437.56H255.574V1796.94",
    stroke: "black",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M511.148 0.00292969V359.39H766.723V0.00292969",
    stroke: "black",
    strokeWidth: 2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 359.393,
    width: 255.574,
    height: 359.387,
    stroke: "black",
    strokeWidth: 2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 718.783,
    width: 255.574,
    height: 359.387,
    stroke: "black",
    strokeWidth: 2
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 511.148,
    y: 1078.17,
    width: 255.574,
    height: 359.387,
    stroke: "black",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M766.723 1796.94V1437.56H511.148V1796.94",
    stroke: "black",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M766.723 0.00292969V359.39H1022.3V0.00292969",
    stroke: "black",
    strokeWidth: 2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 359.393,
    width: 255.574,
    height: 359.387,
    stroke: "black",
    strokeWidth: 2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 718.783,
    width: 255.574,
    height: 359.387,
    stroke: "black",
    strokeWidth: 2
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 766.723,
    y: 1078.17,
    width: 255.574,
    height: 359.387,
    stroke: "black",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.3 1796.94V1437.56H766.723V1796.94",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.3 0.00292969V359.39H1277.87",
    stroke: "black",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.87 359.393H1022.3V718.78H1277.87",
    stroke: "black",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.87 718.783H1022.3V1078.17H1277.87",
    stroke: "black",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.87 1078.17H1022.3V1437.56H1277.87",
    stroke: "black",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.87 1437.56H1022.3V1796.94",
    stroke: "black",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1796H1277",
    stroke: "black",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrow);
export default __webpack_public_path__ + "static/media/grow.629705567ae37266a51a1e93ad7ce5e4.svg";
export { ForwardRef as ReactComponent };